import { MenuItem } from '@mui/material';

export default ({ history, label, to }) => {
    return (
        <MenuItem
            onClick={() => history.push(to)}
        >
            {label}
        </MenuItem>
    )
}